export const CREATE_TAG_MUTATION = `
  mutation CreateTag($object: tags_insert_input!) {
    insert_tags_one(object: $object) {
      id
      name
      tags_color
      tags_page
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;

export const UPDATE_TAG_MUTATION = `
  mutation UpdateTag($id: Int!, $set: tags_set_input!) {
    update_tags_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      name
      tags_color
      tags_page
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;

export const DELETE_TAG_MUTATION = `
  mutation DeleteTag($id: Int!) {
    delete_tags_by_pk(id: $id) {
      id
    }
  }
`;
